import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import SEOConfig, { publisherRef } from "./SEOConfig";

// Head tags for the /videos/* sub-pages (streams, interviews, season highlights). Videos are
// listed by title and YouTube link only: VideoObject would need an uploadDate, and the YouTube
// helpers hand the pages a pre-formatted DD/MM/YY string rather than the real timestamp.
// `robots` lets a page with nothing to show (a season with no highlights yet) opt out of indexing.
const VideoCollectionSEO = ({ title, description, videos = [], robots }) => {
  const location = useLocation();
  const { siteUrl } = SEOConfig;
  const currentUrl = `${siteUrl}${location.pathname}`;

  const breadcrumbs = [
    { name: "Головна", url: siteUrl },
    { name: "Медіа", url: `${siteUrl}/videos` },
    { name: title, url: currentUrl },
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: title,
    description,
    url: currentUrl,
    inLanguage: "uk",
    publisher: publisherRef,
  };
  const listed = videos.filter((video) => video.link && video.title);
  if (listed.length > 0) {
    schema.mainEntity = {
      "@type": "ItemList",
      numberOfItems: listed.length,
      itemListElement: listed.map((video, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: video.title,
        url: video.link,
      })),
    };
  }

  return (
    <SEO
      title={title}
      description={description}
      keywords={["Slick Racing Ukraine відео", "iRacing", title]}
      url={currentUrl}
      schema={schema}
      canonical={currentUrl}
      type="website"
      breadcrumbs={breadcrumbs}
      robots={robots}
      lang="uk"
    />
  );
};

export default VideoCollectionSEO;
